const SET_ISPIL_PAGE_DATA = 'SET_ISPIL_PAGE_DATA';
const SET_PIL_STICKER_DETAILS = 'SET_PIL_STICKER_DETAILS';
export default {
  namespaced: true,
  state: {
    isPILPage: false,
    PILStickerData: {
      gradeImage: '',
      gradeValue: '',
      gradeImageAlt: '',
      scoreTextStatement: '',
      readMoreTextPIL: ''
    }
  },
  actions: {},
  mutations: {
    [SET_ISPIL_PAGE_DATA]: (state, data) => {
      state.isPILPage = data;
    },
    [SET_PIL_STICKER_DETAILS]: (state, data) => {
      state.PILStickerData.gradeImage = data.GlobalEnvironmentSustainabilityGradeImage;
      state.PILStickerData.gradeValue = data.GlobalEnvironmentSustainabilityGradeValue;
      state.PILStickerData.gradeImageAlt = data.GradeImageAlt;
      state.PILStickerData.scoreTextStatement = data.stickerScoreText;
      state.PILStickerData.readMoreTextPIL = data.readMoreText;
    }
  }
};
